var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"fireworks-canvas",class:{ 'day-mode': _vm.dayMode },on:{"click":_vm.addFirework}})
}
var staticRenderFns = []

export { render, staticRenderFns }